module.exports = __webpack_public_path__ + "img/ssl_secure.89df133a.svg";